module.exports = "<p>\r\n  dialog-box works!\r\n</p>\r\n"